import { render, staticRenderFns } from "./ATradeTable.vue?vue&type=template&id=1cb1ff36&scoped=true&"
import script from "./ATradeTable.vue?vue&type=script&lang=js&"
export * from "./ATradeTable.vue?vue&type=script&lang=js&"
import style0 from "./ATradeTable.vue?vue&type=style&index=0&id=1cb1ff36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb1ff36",
  null
  
)

export default component.exports